import * as Sentry from '@sentry/react'

// Read from the runtime-injected window._env_ (generated by env.sh at container
// startup) with a build-time fallback — import.meta.env alone is always empty in
// Docker images since they are built once and configured per environment.
// Kept dependency-free so Sentry initializes before any app module loads.
const runtimeEnv: Record<string, string | undefined> =
  (typeof window !== 'undefined' && window._env_) || {}

// A DSN is always a URL — this also ignores unresolved CI placeholders
// (e.g. a literal "$(VITE_SENTRY_DSN)" when the pipeline variable is undefined)
const rawDsn = runtimeEnv.VITE_SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN || ''
const dsn = rawDsn.startsWith('http') ? rawDsn : ''
const environment = runtimeEnv.NODE_ENV || import.meta.env.MODE

Sentry.init({
  dsn,
  environment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Only propagate `sentry-trace` / `baggage` headers to our own API gateway.
  // Sentry substring-matches string targets, so a bare 'localhost' entry also
  // hit every local bridge the app talks to from the practitioner's machine
  // (MedConnect devices :4000, Carte Vitale :4001, socket-wrapper :3400,
  // DMP-Connect on localhost.icanopee.net). Those servers do not allow these
  // headers in their CORS preflight, which broke the device connection in prod.
  tracePropagationTargets: [
    /^http:\/\/localhost:3000\/api/,
    /^https:\/\/.*\.promotal\.com\/api/,
    /^https:\/\/.*\.medconnect\.com\/api/,
  ],
  // 100% in dev/staging, 20% in production
  tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
  // Session replay: 10% of sessions, 100% when an error occurs
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Only enable if DSN is configured
  enabled: !!dsn,
})
